/**
 * @group Network
 * @summary Network error codes for specific network-related failures
 * 
 * @remarks
 * This constant contains network error codes used to identify specific
 * types of network failures for targeted error handling.
 * 
 * @example
 * ```typescript
 * import { NETWORK_ERROR_CODES } from '@shared/constants';
 * 
 * function nextErrorResponse(error: any): string {
 *   switch (error.code) {
 *     case NETWORK_ERROR_CODES.ECONNREFUSED:
 *       return 'Connection refused';
 *     case NETWORK_ERROR_CODES.ETIMEDOUT:
 *       return 'Connection timed out';
 *     default:
 *       return 'Unknown error';
 *   }
 * }
 * ```
 */
export const /**
 * @internal
 */
NETWORK_ERROR_CODES = {
  // Connection codes
  ECONNREFUSED: 'ECONNREFUSED',
  ECONNRESET: 'ECONNRESET',
  ECONNABORTED: 'ECONNABORTED',
  ETIMEDOUT: 'ETIMEDOUT',
  ENOTFOUND: 'ENOTFOUND',
  
  // HTTP client error codes
  UND_ERR_CONNECT_TIMEOUT: 'UND_ERR_CONNECT_TIMEOUT',
  UND_ERR_HEADERS_TIMEOUT: 'UND_ERR_HEADERS_TIMEOUT',
  UND_ERR_BODY_TIMEOUT: 'UND_ERR_BODY_TIMEOUT',
  
  // Fetch API error codes
  FETCH_ERROR: 'FETCH_ERROR',
  ABORT_ERR: 'ABORT_ERR',
  NETWORK_ERR: 'NETWORK_ERR',
  
  // Custom application codes
  DB_CONNECTION_FAILED: 'DB_CONNECTION_FAILED',
  DB_QUERY_TIMEOUT: 'DB_QUERY_TIMEOUT',
  API_RATE_LIMITED: 'API_RATE_LIMITED',
} as const; 